'use client'

import {
  PricingCard,
  PricingCardButton,
  PricingCardContent,
  PricingCardFeatureLine,
  PricingCardFeatureLineDescription,
  PricingCardFeatureLineIcon,
  PricingCardFeatures,
  PricingCardFooter,
  PricingCardHeader,
  PricingCardInfo,
  PricingCardPrice,
  PricingCardPriceAmount,
  PricingCardPriceAmountFormatted,
  PricingCardPricePeriod,
  PricingCardTitle,
  PricingCardTitleIcon,
  PricingTable,
  usePricing,
} from '@autosign/core'
import * as Icons from '@tabler/icons-react'
import { ListPublicPlansResponseBody } from 'bff'
import { cn } from 'ui'

const buildPlanLink = ({
  plan,
  price,
}: {
  plan: ListPublicPlansResponseBody['plans'][number]
  price: ListPublicPlansResponseBody['plans'][number]['prices'][number]
}) => {
  if (plan.role === 'enterprise') return '/contact'

  if (plan.role === 'paywall')
    return `${process.env.NEXT_PUBLIC_AUTOSIGN_DASHBOARD_BASE_URL}/register?next=/billing/plan/${plan.id}/subscribe?priceId=${price.id}`

  return `${process.env.NEXT_PUBLIC_AUTOSIGN_DASHBOARD_BASE_URL}/register?next=/?from_free_register=true`
}

export const PlansPage = ({ data }: { data: ListPublicPlansResponseBody }) => {
  const pricing = usePricing()

  return (
    <PricingTable>
      {data.plans.map((plan) => {
        const Icon = plan.icon ? Icons[plan.icon] : undefined

        const price = plan.prices.find(
          (price) => price.recurring_interval === pricing.recurringInterval
        )!

        const link = buildPlanLink({ plan, price })

        const showPrice = !!price && plan.role === 'paywall'

        return (
          <PricingCard
            className='pt-0 bg-[#0F1119]'
            key={plan.id}
            value={plan.id}
          >
            <PricingCardHeader className='p-4'>
              <PricingCardInfo>
                <PricingCardTitle className='text-white'>
                  {plan.name}
                </PricingCardTitle>
                {Icon && (
                  <PricingCardTitleIcon className='text-[#DCF765]'>
                    <Icon />
                  </PricingCardTitleIcon>
                )}
              </PricingCardInfo>

              {price ? (
                <PricingCardPrice>
                  <PricingCardPriceAmountFormatted 
                    className='text-[#DCF765]'
                    currency={price.currency}>
                    {price.amount}
                  </PricingCardPriceAmountFormatted>
                  <PricingCardPricePeriod 
                    className='text-[#DCF765]'
                    period={price.recurring_interval} 
                  />
                </PricingCardPrice>
              ) : (
                <PricingCardPrice>
                  <PricingCardPriceAmount  className='text-[#DCF765]'>
                    A contactar
                  </PricingCardPriceAmount>
                </PricingCardPrice>
              )}
            </PricingCardHeader>

            <PricingCardContent
              className={cn({
                'mt-5': !showPrice,
              })}
            >
              <PricingCardFeatures>
                {plan.lines.map((line) => {
                  const Icon = line.icon ? Icons[line.icon] : undefined
                  return (
                    <PricingCardFeatureLine key={line.id}>
                      {Icon && (
                        <PricingCardFeatureLineIcon>
                          <Icon />
                        </PricingCardFeatureLineIcon>
                      )}
                      <PricingCardFeatureLineDescription className='text-white'>
                        {line.description}
                      </PricingCardFeatureLineDescription>
                    </PricingCardFeatureLine>
                  )
                })}
              </PricingCardFeatures>
              <PricingCardFooter className='p-4'>
                <a href={link}>
                  <PricingCardButton>Este plan es para mi</PricingCardButton>
                </a>
              </PricingCardFooter>
            </PricingCardContent>
          </PricingCard>
        )
      })}
    </PricingTable>
  )
}
